var React = require('react');

function Wait (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M12.833 11.167V7c0-.46-.373-.833-.833-.833-.46 0-.833.373-.833.833v5c0 .46.373.833.833.833h4.167c.46 0 .833-.373.833-.833 0-.46-.373-.833-.833-.833h-3.334zM12 20.333c-4.603 0-8.333-3.73-8.333-8.333S7.397 3.667 12 3.667c4.602 0 8.333 3.73 8.333 8.333 0 4.602-3.73 8.333-8.333 8.333z","transform":"translate(0 1)","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","transform":"translate(0 1)","key":1})]));
}

Wait.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25"};

module.exports = Wait;

Wait.default = Wait;
